import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {NumberFormat,MobileFormat,DateThaiFormat,DateFormat,DateThai,GetRole} from '../../Utils/Function';
import { createRoot } from 'react-dom/client';

import Swal from 'sweetalert2';
import API from '../../API';

import VendorInfo from './VendorInfo';


import "react-datepicker/dist/react-datepicker.css";
import '../../Assets/CSS/Horapa.css';

const PageVendorList =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();

    const ref = useRef();
    const _ProductTypeRef = useRef();
    const _ProductCreate = useRef();
    const _ProductTypeCreate = useRef();
    useEffect(() => {
        (async () => {
        })();

        return ()=>{ }
    }, []);
    const _configs = {
        "order": [[0, "asc"]],
        pageLength: 10,
        orderMulti: true
    }
    const _ajax  = {
        'url': '/Vendor/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            //d.ProductTypeID = getValues('ProductTypeID');
        }
    };
    const _ColumnDefs = [
    ]

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' title='ลบ' className='btn btn-danger text-white' onClick={() => _Delete(d,r)}>ลบ</button>
        </div>
    )
    const _Column = [
        { data: "VendorName", name: "VendorName", autoWidth: true },
        { data: "Remark", name: "Remark", autoWidth: true },
        {data: "CreateDate", name: "CreateDate", autoWidth: true,render(data){
            return DateFormat(data,true);
        }},
        {
            data: "VendorId", name: "VendorId", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]

    const _Delete = async(VendorID,val) =>{
        Swal.fire({
            icon: 'warning',
            title: 'ต้องลบ '+val.VendorName+' หรือไม่ ?',
            text : '',
            showCancelButton : true,
            confirmButtonText: 'ลบ',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }
            API({method : "delete",url:"/Vendor/"+VendorID}).then(res=>{
                if(!res.data.Status){
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });
                    return;
                }
                ref.current?.load();
            }).catch(res => {
                return;
            });
        });
    }

    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                    <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>จัดการคู่ค้า</h3>
                            </div>
                            <div className='card-body' style={{'minHeight':'300px'}}>
                                
                               <div className='row d-flex justify-content-end'>
                                        <div className='col-1 col-lg-1 mt-2 float-end'>
                                            <div className="input-group mb-3">
                                                <button type='button'  className='btn btn-primary text-white' onClick={()=>{_ProductCreate.current?.Show();}}>เพิ่มคู่ค้า</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-lg-12 table-responsive">
                                            <table id="VendorListView" className='table w-100' role='grid'>
                                                <thead>
                                                    <tr>
                                                        <th className="text-center textcenter">ชื่อคู่ค้า</th>
                                                        <th className="text-center textcenter">หมายเหตุ</th>
                                                        <th className="text-center textcenter">วันที่แก้ไข</th>
                                                        <th className="text-center no-sort"></th>
                                                    </tr>
                                                </thead>
                                                <DataTable TableID={"VendorListView"} Column={_Column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                            </table>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
        <VendorInfo ref={_ProductCreate} Reload={()=>{ref.current?.load();}} />
        </>
    )
}

export default React.memo(PageVendorList)
